import React from 'react';
import styled from 'styled-components';
import ProgressiveImage from 'react-progressive-image';
//
export default ({ accessibility_caption, dimensions, display_url }) => {
  const alt = accessibility_caption;
  const { height, width } = dimensions;
  const src = display_url;

  const styles = {
    paddingBottom: `${(height / width) * 100}%`
  };

  return (
    <Wrap style={styles}>
      <ProgressiveImage src={src}>
        {(src, loading) => (
          <Image alt={alt} src={src} loading={loading} {...dimensions} />
        )}
      </ProgressiveImage>
    </Wrap>
  );
};

const Image = React.memo(
  ({ loading, ...rest }) => (
    <Img style={{ opacity: loading ? 0 : 1 }} {...rest} />
  ),
  (prev, next) => prev.src === next.src || next.loading
);
//
const Wrap = styled.figure`
  height: 0;
  width: 100%;
`;
export const Img = styled.img`
  object-fit: contain;
  transition: opacity 420ms ease-in;
  width: 100%;
`;
